/**
 * External dependencies
 */
import { IconListIcon } from '~cartzillagb/icons'
import { range } from '~cartzillagb/util'
import {
	disabledBlocks,
	i18n,
	srcUrl
} from 'cartzillagb'

/**
 * Internal dependencies
 */
import save from './save'
import edit from './edit'
import DefaultImage  from  './img/img2.jpg'


/**
 * WordPress dependencies
 */
import { applyFilters } from '@wordpress/hooks'
import { __ } from '@wordpress/i18n'


export const schema = {
	blockId: {
		type: 'string',
	},
	className : {
		type: 'string',
	},
	enableButton : {
		type: 'boolean',
		default: true
	},
	design : {
		type: 'string',
		default: 'style-1'
	},
	postperslide : {
		type: 'number',
		default: 4,
	},
	enableContainer: {
		type: 'boolean',
		default: true,
	},
	displayboxShadow: {
		type: 'boolean',
		default: false,
	},
	slidesToScroll: {
		type: 'number',
		default: 4,
	},
	postsToShow: {
		type: 'number',
		default: 6,
	},
	slidesToShow: {
		type: 'number',
		default: 4,
	},
	displaySectionHeader: {
		type: 'boolean',
		default: true,
	},
	displayReviewDate: {
		type: 'boolean',
		default: true,
	},
	displayAuthorName: {
		type: 'boolean',
		default: true,
	},
	displayAuthorImage: {
		type: 'boolean',
		default: true,
	},
	displayStarRatings: {
		type: 'boolean',
		default: true,
	},
	heading : {
		type: 'string',
	},
	background : {
		type: 'string',
	},
	backgroundColor : {
		type: 'string',
	},
}

const maxLimit = applyFilters( 'cartzillagb.review-carousel.edit.inspector.max.limit', 12 )
{ range( 1, maxLimit + 1 ).forEach( i => {

	schema[ `authorImage${ i }` ] = {
		type: 'string',
		default: `${ srcUrl }/${ DefaultImage }`
	}
	schema[ `authorname${ i }` ] = {
		type: 'string',
	}
	schema[ `reviewdate${ i }` ] = {
		type: 'string',
	}
	schema[ `starRatings${ i }` ]  = {
		type: 'number',
		default: 5
	}
	schema[ `review${ i }` ]  = {
		type: 'string',
	}

} ) }


export const name = 'czgb/review-carousel'

export const settings = {
	title: __( 'Testimonials', i18n ),
	description: __( 'Display reviews & testimonials from your customers in a carousel.', i18n ),
	icon: IconListIcon,
	category: 'cartzillagb',
	example: {},
	keywords: [
		__( 'review-carousel', i18n ),
		__( 'CartzillaGb', i18n ),
	],
	attributes: schema,
	supports: {
		inserter: ! disabledBlocks.includes( name ), // Hide if disabled.
	},

	edit,
	save,

	// CartzillaGB modules.
	modules: {
		'advanced-responsive': true,
	},
}
